import React from "react";
import { formatGBP } from "../../utils/currency";

interface PropsType {
  [x: string]: any;
}
export default function PaymentCalculation(props: PropsType) {
  return (
    <div className="calculation_box">
      <div className="calculation_main">
        <p>
          Current Premium:{" "}
          <span>{formatGBP(props.calculatedData?.currentPremium)}</span>
        </p>
        <p>
          Frequency: <span>{props.calculatedData?.currentFrequency}</span>
        </p>
        <p>
          Single Premium:{" "}
          <span>{formatGBP(props.calculatedData?.totalSinglePremiums)}</span>
        </p>
        <p>
          Total Paid to Date:{" "}
          <span>{formatGBP(props.calculatedData?.totalPaidToDate)}</span>
        </p>
        <p>
          Current Monthly Payment:{" "}
          <span>{formatGBP(props.calculatedData?.currentRegular)}</span>
        </p>
      </div>
    </div>
  );
}
